// extracted by mini-css-extract-plugin
export var clickThrough = "_yh-2";
export var fallback = "_yh-5";
export var frame = "_yh-3";
export var frameCell = "_yh-1";
export var overlay = "_yh-4";
export var wrapper = "_yh-0";